import {
  Shield,
  FileText,
  Clock,
  MapPin,
  Mail,
  Phone,
  Users,
  AlertTriangle,
  Zap,
  CreditCard,
} from 'lucide-react';



export const TermsOfService = () => {
  return (
    <div className="min-h-screen pt-20 bg-gray-50">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-[#1B4F72] to-[#138808] text-white py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <div className="w-20 h-20 bg-white/20 rounded-2xl flex items-center justify-center mx-auto mb-6">
            <FileText className="w-10 h-10" />
          </div>
          <h1 className="text-5xl font-bold mb-6">Terms of Service</h1>
          <p className="text-xl text-gray-100 max-w-2xl mx-auto leading-relaxed">
            By using Mahasarathi, you agree to these terms governing platform usage, bookings and services.
          </p>
        </div>
      </section>

      <section className="py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto space-y-12">
          <div className="bg-white rounded-2xl shadow-xl p-8 border border-gray-100">
            <h2 className="text-3xl font-bold text-[#1B4F72] mb-8">1. Acceptance of Terms</h2>
            <p className="text-gray-600 leading-relaxed text-lg mb-8">
              By accessing or using the Mahasarathi platform (website, mobile app, APIs), you agree to be bound by these Terms of Service, 
              our Privacy Policy, and all applicable laws. If you do not agree, please do not use our services.
            </p>
          </div>

          <div className="space-y-8">
            <div className="bg-white rounded-2xl shadow-xl p-8 border border-gray-100">
              <h3 className="text-2xl font-bold text-[#1B4F72] mb-6 flex items-center gap-3">
                <Clock className="w-7 h-7" />
                2. Service Description
              </h3>
              <p className="text-gray-600 leading-relaxed mb-6">
                Mahasarathi provides multi-modal mobility services including route planning, real-time ETAs, unified booking, and live tracking 
                across buses, trains, metros, cabs, and other transport modes through integrations with authorized operators.
              </p>
              <ul className="grid md:grid-cols-2 gap-4 text-sm">
                <li>• We are a technology platform, not a transport operator</li>
                <li>• All bookings executed through partner operators</li>
                <li>• Real-time data subject to operator accuracy</li>
                <li>• Service availability varies by location/operator</li>
              </ul>
            </div>

            <div className="bg-white rounded-2xl shadow-xl p-8 border border-gray-100">
              <h3 className="text-2xl font-bold text-[#1B4F72] mb-6 flex items-center gap-3">
                <CreditCard className="w-7 h-7" />
                3. Payments & Refunds
              </h3>
              <div className="grid md:grid-cols-2 gap-8">
                <div>
                  <h4 className="font-semibold text-lg mb-4">Payment Terms</h4>
                  <ul className="space-y-2 text-gray-600 text-sm">
                    <li>• All payments processed via PCI-compliant gateways</li>
                    <li>• UPI, cards, wallets, net banking supported</li>
                    <li>• Prices displayed inclusive of platform fee</li>
                    <li>• Currency: INR only</li>
                  </ul>
                </div>
                <div>
                  <h4 className="font-semibold text-lg mb-4">Refund Policy</h4>
                  <ul className="space-y-2 text-gray-600 text-sm">
                    <li>• Operator cancellation: Full refund within 15 mins</li>
                    <li>• User cancellation: Per-operator policy</li>
                    <li>• No-shows: Non-refundable</li>
                    <li>• Processing fees non-refundable</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-r from-[#FF9933] to-[#E68A2E] rounded-2xl p-8 text-white">
              <h3 className="text-2xl font-bold mb-6 flex items-center gap-3">
                <AlertTriangle className="w-7 h-7" />
                4. User Responsibilities
              </h3>
              <div className="grid md:grid-cols-2 gap-6 text-lg">
                <div>• Comply with all applicable transport laws</div>
                <div>• Provide accurate booking information</div>
                <div>• Respect operator/driver instructions</div>
                <div>• Report issues within 2 hours of service</div>
                <div>• No abusive behavior toward staff/partners</div>
              </div>
            </div>

            <div className="bg-white rounded-2xl shadow-xl p-8 border border-gray-100">
              <h3 className="text-2xl font-bold text-[#1B4F72] mb-6">5. Limitation of Liability</h3>
              <p className="text-gray-600 leading-relaxed mb-6">
                Mahasarathi provides information and booking facilitation services. We do not guarantee service availability, 
                ETA accuracy, or operator performance. Maximum liability limited to booking amount paid.
              </p>
            </div>

            <div className="bg-white rounded-2xl shadow-xl p-8 border border-gray-100">
              <h3 className="text-2xl font-bold text-[#1B4F72] mb-6">6. Termination</h3>
              <p className="text-gray-600 leading-relaxed">
                We reserve the right to suspend/terminate accounts for violation of terms, fraudulent activity, 
                or at operator discretion. Terminated users forfeit platform credits.
              </p>
            </div>
          </div>

          <div className="text-center pt-12 border-t border-gray-200 space-y-4">
            <p className="text-sm text-gray-500">
              Last updated: December 27, 2025 | Governing Law: India
            </p>
            <p className="text-sm text-gray-500">
              Disputes resolved under Telangana jurisdiction
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};
